import React from 'react';
import { DateRangeFilter } from '../DateRangeFilter';
import { RangeItem } from '@wix/bex-core';
import { FilterProps } from '../../model';
import { DateCustomFieldFilterBase } from './DateCustomFieldFilterBase';

interface DateTimeCustomFieldFilterProps extends FilterProps<RangeItem<Date>> {}

export const DateTimeCustomFieldFilter = (
  props: DateTimeCustomFieldFilterProps,
) => {
  return <DateCustomFieldFilterBase {...props} filterByTime />;
};

DateTimeCustomFieldFilter.renderPresetToolbarTag =
  DateRangeFilter.renderPresetToolbarTag;
